import React from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import FFLink from '../../components/FFLink';
import styles from './HeaderText.module.css';

/** @type Object.<string, Object.<string, string>> */
const HEADER_SIZE_MAP = {
  'Big Chungus': {
    className: 'bigChungus',
    tag: 'h1',
  },
  'Header 1': {
    className: 'header1',
    tag: 'h1',
  },
  'Header 2': {
    className: 'header2',
    tag: 'h2',
  },
  'Header 3': {
    className: 'header3',
    tag: 'h3',
  },
  'Header 4': {
    className: 'header4',
    tag: 'h4',
  },
  'Header 5': {
    className: 'header5',
    tag: 'h5',
  },
  'Header 6': {
    className: 'header6',
    tag: 'h6',
  },
};

/** @type {Object<string, import('@contentful/rich-text-react-renderer').NodeRenderer>} */
const renderOptions = {
  // get around the fact that rich text comes back wrapped in some kind of tag, in this case <p>
  [BLOCKS.PARAGRAPH]: (node, children) => children,
  [INLINES.HYPERLINK]: (node, children) => (
    <FFLink url={node.data.uri}>{children}</FFLink>
  ),
};

/**
 * @param {FF.ContentfulHeaderText} props
 */
export default function HeaderText({
  allowH1 = false,
  body,
  fontFamily,
  headerSize,
}) {
  const { className } = HEADER_SIZE_MAP[headerSize];
  let { tag } = HEADER_SIZE_MAP[headerSize];

  if (tag === 'h1' && !allowH1) {
    tag = 'h2';
  }

  return React.createElement(
    tag,
    {
      className: styles[className + (fontFamily === 'Roboto' ? 'Normal' : '')],
    },
    renderRichText(body, {
      renderNode: renderOptions,
    }),
  );
}
